import { cn } from "@/lib/utils/global-utils";
import React from "react";

import Image from "next/image";

interface ProductShowcaseCardProps
  extends React.HtmlHTMLAttributes<HTMLDivElement> {
  imagePath: string;
}

const ProductShowcaseCard = React.forwardRef<
  HTMLDivElement,
  ProductShowcaseCardProps
>(({ imagePath, className, ...rest }, ref) => {
  return (
    <div
      className={cn(
        "bg-white rounded-2xl size-[8.75rem] shadow-container shrink-0 opacity-50 ",
        className
      )}
      ref={ref}
      {...rest}
    >
      <Image
        quality={100}
        src={imagePath}
        className=" object-scale-down"
        alt="Showcase Product Image"
        width={140}
        height={140}
      />
    </div>
  );
});
ProductShowcaseCard.displayName = "Product Showcase Card";
export default ProductShowcaseCard;
